import { useState, useEffect } from 'react'

// Mobile breakpoint matching theme.ts MEDIA.mobile (max-width: 768px)
const MOBILE_BREAKPOINT = 768

/** Detects whether the viewport is at mobile width */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth <= MOBILE_BREAKPOINT : false
  )

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return isMobile
}
